<template>
  <div>
    <h3>{{ $t('message.script_logs_own_padmin_activity') | title }}</h3>
    <b-container fluid>
      <b-row>
        <b-col lg="6">
          <b-form-group :label="$t('message.script_logs_activity_search')" label-for="filter-input"
            label-cols-sm="3" label-align-sm="right" label-size="sm" class="mb-0" >
            <b-input-group size="sm">
              <b-form-input id="filter-input" v-model="filter" type="search"
                :placeholder="$t('message.script_logs_own_padmin_activity_search_placeholder')">
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>
    <b-table striped hover :items="activityLog" :fields="fields" :filter="filter"
      :filter-included-fields="filterOn" class="table-responsive">
      <template #cell(unstuck)="row">
        <svg v-if="row.item.business_result == 'InProgress' || row.item.business_result == 'InUpload'"
          class='icon icon-stop' @click="unstuckActivityLogEntry(row.item, row.index)">
          <title>{{$t("message.button_unstuck")}}</title>
        </svg>
      </template>
    </b-table>
  </div>
</template>

<script>
import ConsoleOutput from "./ConsoleOutput";
import { get, post } from "../http";

export default {
  name: "OwnPadminActivityLog",

  components: {
    ConsoleOutput
  },

  data() {
    return {
      output: '',
      fields: [
        {key: 'start_date', sortable: true}, {key: 'duration', sortable: true, label: 'Duration (sec)'},
        {key: 'action', sortable: true}, {key: 'business_result', sortable: true},
        {key:'details', sortable: false}, {key:'comment', sortable: false}, 'unstuck'],
      activityLog: [],
      selectedLogEntryIndex: null,
      filter: null,
      filterOn: ['action']
    };
  },

  mounted() {
    this.loadActivityLog()
  },

  methods: {
    showOutPut(logEntryIndex) {
      this.selectedLogEntryIndex = logEntryIndex
      this.output = null
      this.result = null
      let commandId = this.activity_log[logEntryIndex].command_id
      get("/command_progress/" + commandId).then(
        resp => {
            this.output = resp.data.output
            this.result = resp.data.result
        },
        err => {
          console.log("err", err)
        }
      )
    },

    loadActivityLog() {
      get('/own_padmin_activity_log').then(
        resp => {
          this.activityLog = resp.data
          for (let index = 0; index < this.activityLog.length; index++) {
            let logEntry = this.activityLog[index]
            logEntry.action = logEntry.type.substring(6)
            if (logEntry.details && logEntry.details.startsWith('license') && !logEntry.details.includes('***')) {
              logEntry.details = logEntry.details.substring(0, 50) + '...'
            }
          }
        },
        err => {
          console.log("err", err)
        }
      )
    },

    unstuckActivityLogEntry(actLogEntry, actLogEntryIndex) {
      post("/unstuck_activity_log_entry/" + actLogEntry._id).then(
        resp => {
          this.activityLog[actLogEntryIndex].business_result = resp.data.business_result
        },
        err => {
          console.log("err", err)
        }
      )
    }
  }
}
</script>
<style scoped>
.table td{
  height: 65px;
  overflow: auto;
  display: inline-block;
}
</style>
